export default "__VITE_ASSET__c82e65cd__"